import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { JackingActivityFileUploadModalComponent } from './jacking-activity-file-upload-modal';
import { NgxFileDropModule } from 'ngx-file-drop';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  declarations: [
    JackingActivityFileUploadModalComponent,
  ],
  imports: [
    IonicPageModule.forChild(JackingActivityFileUploadModalComponent),
    NgxFileDropModule,
    SharedModule
  ],
entryComponents: [
  JackingActivityFileUploadModalComponent
]
})
export class JackingActivityFileUploadModalComponentModule {}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v1/jacking-activity-file-upload-modal/jacking-activity-file-upload-modal.module.ts